'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { forwardRef, useCallback, useMemo, } from 'react';
import { Icon, Spinner, useStyles, } from '../../index.js';
import styles from './button.module.css';
const iconSize = {
    big: 18,
    regular: 18,
    small: 14,
};
export const Button = forwardRef(({ as: Component = 'button', kind = 'primary', dimension = 'regular', className, children, fullWidth, icon, iconOpticalSize, disabled, iconPosition = 'start', iconColor, type = 'button', onClick, busy, sentiment, ...otherProps }, forwardedRef) => {
    const { vibrancy } = useStyles();
    const handleClick = useCallback((event) => {
        if (!disabled && onClick)
            onClick(event);
        if (disabled)
            event.preventDefault();
    }, [disabled, onClick]);
    const renderIcon = useMemo(() => icon && (_jsx(Icon, { source: icon, fill: iconColor, dimension: iconOpticalSize?.[dimension] ?? iconSize[dimension] })), [icon, dimension, iconColor, iconOpticalSize]);
    return (_jsxs(Component, { ref: forwardedRef, type: Component === 'button' ? type : undefined, className: clsx(styles.Button, className), "data-button-icon-position": iconPosition, "data-button-dimension": dimension, "data-button-kind": kind, "data-button-sentiment": sentiment, "data-button-fullwidth": fullWidth, "aria-disabled": disabled, disabled: busy, "aria-busy": busy, "aria-live": busy ? 'polite' : undefined, onClick: handleClick, ...(kind === 'primary' || kind === 'secondary') ? vibrancy.attributes : undefined, ...otherProps, children: [renderIcon, (children && busy) ? _jsx("span", { children: children }) : children, busy && (_jsx("span", { className: styles.SpinnerIndicator, children: _jsx(Spinner, { dimension: dimension }) }))] }));
});
